import React from "react";
import { PageData } from "../dynamic-page/DynamicPageContent";

const benefitTopics = [
  "Aid and Attendance/Home Care",
  "Veteran Compensation and Pension Benefits",
  "Veterans Survivor Benefits",
  "Veteran Burial Benefits",
  "Veterans Benefits",
  "Legal",
];

// slug generator
const createSlug = (text: string) =>
  text
    .toLowerCase()
    .replace(/\s+/g, "-")          // spaces → hyphens
    .replace(/[^a-z0-9-]/g, "-")   // special chars → hyphens
    .replace(/-+/g, "-")           // remove extra hyphens
    .replace(/^-|-$/g, "");        // trim hyphens at start/end


const BenefitsSection = ({ pageData }: { pageData: PageData }) => {

  const benefitTopics = pageData.specifications?.find((spec: any) => spec.key === 'resources')?.value || [];
  
  return (
    <section className="connect-sec">
      <div className="container">
        <div className="row">
          {/* Heading */}
          <div className="col-lg-12">
            <div className="head mb-lg-4">
              <h2>
                Explore <span>{pageData?.title}</span> Topics
              </h2>
            </div>
          </div>

          {/* Topics List */}
          <div className="col-lg-12">
            <div className="connect-box">
              <div className="row">
                {benefitTopics.map((topic: any, index: number) => (
                  <div className="col-lg-4" key={index}>
                    <div className="service-box">
                      <h5>{topic.title}</h5>
                      <div className="card-btn">
                        <a
                          href={topic?.link ? topic?.link : `/blog/${createSlug(topic?.title)}`}
                          className="btn"
                        >
                          <img
                            src="/images/icons/black_icon.svg"
                            className="arrow-icon"
                            alt=""
                          />
                        </a>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
